import orderFormFields from "./orderFormFields";

export default [
  {
    label: "Serial Number",
    name: "serialNumber",
    type: "text",
    required: true,
  },
  {
    label: "Brand",
    name: "brand",
    type: "select",
    options: [
      "ResMed",
      "Apex",
      "BMC",
      "Yuwell",
      "VentMed",
      "Topson",
      "Philips",
      "Other",
    ],
  },
  {
    label: "Model",
    name: "model",
    type: "select",
    options: [
      "XT-Auto",
      "AirSense 10 AutoSet",
      "AirSense 10 AutoSet for Her",
      "AirSense 10 Elite",
      "AirSense 11 AutoSet",
      "AirMini AutoSet",
      "DF Series",
      "AirStart 10",
      "Sound Sleep",
      "DreamStation CPAP PRO",
      "DreamStation AUTO CPAP",
      "DreamStation AUTO CPAP w/o Humid",
      "Other",
    ],
  },
  {
    label: "Type",
    name: "type",
    type: "select",
    options: ["APAP", "CPAP", "BPAP", "Other"],
  },
  {
    label: "Description",
    name: "description",
    type: "text",
  },
  {
    label: "Vendor",
    name: "vendor",
    type: "select",
    options: [
      "ResMed",
      "Skyline Medical",
      "SaintMed",
      "BluePoint",
      "Devers Health",
      "3N",
      "Fondooz",
      "MIC",
      "Hunan VentMed",
      "Other",
    ],
  },
  {
    label: "Device No",
    name: "deviceNo",
    type: "text",
    required: true,
    description: '*ถ้าไม่มีให้กรอก "---" ',
  },
  { label: "Lot No", name: "lotNo", type: "text" },
  { label: "Incoming Date", name: "incomingDate", type: "date" },

  {
    label: "Status",
    name: "status",
    type: "select",
    options: ["ว่าง", "จอง", "ขาย", "ยกเลิก", "เครื่องตัวอย่าง"],
  },
  orderFormFields[14],
  { label: "CPAP Image", name: "cpapImage", type: "file" },
  { label: "Note", name: "note", type: "textarea" },
];
